//
// SectionController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "../../models/view/Section";
import "./HeaderController";
import "./BodyController";
import "./VisualController";
import "../../models/visualElements/VisualElement";
import "../interactions/autointeraction/AutoInteractionController";
import "@sas-dvr/ltjs-commons/styles/Style";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "@sas-dvr/ltjs-commons/selection/SelectionControl";

var SectionController = createModule("BIRD::SectionController", ["BIRD::BIRDModelController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getAllVisualControllers: [[1]],
        getModel: [1],
        getSelectionControl: [1],
        areLinkFiltersActive: [2],
        isInfoWindow: [2],
        getKeyVisual: [1],
        getBodyController: [1],
        isContentComplete: [2],
        getAutoInteractionController: [1],
        getPagePadding: [1],
        getAllVisualElements: [[1]],
        areSectionFiltersActive: [2],
        getStyle: [1],
        isHiddenSection: [2],
        setLinkFiltersActive: [0,2],
        getSectionIndex: [4],
        getHeaderController: [1],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default SectionController;
